import React, { useEffect, useState, useCallback } from "react";
import {
  View,
  Text,
  ScrollView,
  Dimensions,
  RefreshControl,
  Image,
  Platform,
} from "react-native";
import AppBar from "../Layout/AppBar";
import { ids, styles } from "./TripDashboardCss";
import { Button, SegmentedButtons } from "react-native-paper";
import TripCard from "./TripCard/TripCard";
import { GetFilterTripAPI } from "../../service/api/trip/api";
import { CreateTripModal } from "./CreateTripModal/CreateTripModal";
import NotFoundTripCard from "./TripCard/NotFoundTripCard";
import { useNavigation } from "@react-navigation/native";
import SearchTrip from "./SearchTrip/SearchTrip";
import { GetUserAPI } from "../../service/api/user/getUserApi";
import {
  resetState,
  setPermission,
  setUserData,
} from "../../store/slices/authSlice";
import {
  primaryColor,
  subTextColor,
  whiteColor,
} from "../../constant/constantCss";
import { showToast } from "../../constant/toastMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  PERMISSION,
  get_user_permission,
} from "../../constant/getAllPermission";
import AsyncStorage from "@react-native-async-storage/async-storage";
import TripFilterModal from "./TripFilterModal/TripFilterModal";
import PlaneLoader from "../../components/Loader";
import ContactUs from "../LnadingPage/components/ContactUs";

const TripDashbaord = ({ route }) => {
  const navigation = useNavigation();
  const { width } = Dimensions.get("window");
  const [upComingTrip, setUpComingTrip] = useState([]);
  const [loader, setloader] = useState(false);
  const screenHeight = Dimensions.get("window").height;
  const [isVisibleCreateModal, setisVisibleCreateModal] = useState(false);
  const [isVisibleFilterModal, setIsVisibleFilterModal] = useState(false);
  const [tabValue, setTabValue] = useState("upcoming");
  const [refreshing, setRefreshing] = useState(false);
  const dispatch = useDispatch();
  const { permission } = useSelector((state) => state.auth);
  const initialCallingAPI = () => {
    setloader(true);
    // call API for get upcoming trips
    GetFilterTripAPI(tabValue)
      .then((res) => {
        setUpComingTrip(res.data?.data);
        setloader(false);
      })
      .catch((err) => {
        showToast("error", err?.response?.data?.detail);
        setloader(false);
      });
  };
  useEffect(() => {
    // call API for get all permission for user
    get_user_permission().then((val) => {
      dispatch(setPermission(JSON.parse(val)));
    });
    // call API for user details
    GetUserAPI()
      .then((res) => {
        dispatch(setUserData(res.data));
      })
      .catch((err) => {
        showToast(
          "error",
          err?.response?.data?.detail,
          "Re-direct to login page, please re-login"
        );
        AsyncStorage.clear();
        dispatch(resetState());
        navigation.replace("Login");
      });
  }, []);
  useEffect(() => {
    initialCallingAPI();
  }, [route.params?.refresh, tabValue]);
  const currentButtonStyle = (val) => ({
    borderWidth: 0,
    borderBottomWidth: 2,
    borderRadius: 2,
    backgroundColor: whiteColor,
    borderColor: tabValue === val ? primaryColor : whiteColor,
  });
  const tabButton = [
    {
      value: "upcoming",
      label: "Upcoming Trips",
      style: currentButtonStyle("upcoming"),
    },
    {
      value: "feature",
      label: "Feature Trips",
      style: currentButtonStyle("feature"),
    },
    {
      value: "all",
      label: "All Trips",
      style: currentButtonStyle("all"),
    },
  ];

  const handleInvisibleModal = () => {
    setisVisibleCreateModal(false);
    GetFilterTripAPI(tabValue)
      .then((res) => {
        setUpComingTrip(res.data?.data || []);
        setloader(false);
      })
      .catch((err) => {
        showToast("error", err?.response?.data?.detail);
        setloader(false);
      });
  };
  const onRefresh = useCallback(() => {
    setRefreshing(true);
    setTimeout(() => {
      initialCallingAPI();
      setRefreshing(false);
    }, 1000);
  }, []);
  return (
    <View style={{ backgroundColor: whiteColor, minHeight: screenHeight }}>
      <AppBar />
      <ScrollView
        refreshControl={
          <RefreshControl
            refreshing={refreshing}
            onRefresh={onRefresh}
            tintColor={primaryColor}
            colors={[primaryColor]}
          />
        }
      >
        {/* Upcoming Trip */}
        <View style={styles.container} dataSet={{ media: ids.container }}>
          <View style={styles.tabView}>
            <ScrollView horizontal={true}>
              <SegmentedButtons
                value={tabValue}
                style={{ width: Platform.OS === "web" ? "150%" : "100%" }}
                onValueChange={setTabValue}
                buttons={tabButton}
              />
            </ScrollView>
          </View>
          <View
            style={styles.containerFlex}
            dataSet={{ media: ids.containerFlex }}
          >
            <View style={styles.flexRow}>
              <SearchTrip
                setTripDetails={setUpComingTrip}
                filterValue={tabValue}
              />
              <Button
                mode="outlined"
                icon={"filter"}
                textColor={subTextColor}
                style={{ borderRadius: 10, marginBottom: 10 }}
                onPress={() => {
                  setIsVisibleFilterModal(true);
                }}
              >
                {width >= 480 && "Filter"}
              </Button>
            </View>
            {permission && permission?.includes(PERMISSION.CAN_CREATE_TRIP) && (
              <Button
                mode="contained"
                buttonColor={primaryColor}
                icon={"plus"}
                onPress={() => setisVisibleCreateModal(!isVisibleCreateModal)}
              >
                Create Trip
              </Button>
            )}
          </View>
          <View
            style={styles.CardFlexContainer}
            dataSet={{ media: ids.CardFlexContainer }}
          >
            {loader ? (
              <PlaneLoader />
            ) : upComingTrip?.length > 0 ? (
              upComingTrip?.map((item, index) => (
                <TripCard
                  key={index}
                  id={item.id}
                  title={item.title}
                  address={item.address}
                  is_public={item.is_public}
                  amount={item.amount}
                  image={item.image_url}
                  departure_date={item.departure_date}
                  no_of_days={item.no_of_days}
                />
              ))
            ) : (
              <NotFoundTripCard />
            )}
          </View>
        </View>
        <ContactUs />
      </ScrollView>
      {isVisibleCreateModal && (
        <CreateTripModal
          visible={isVisibleCreateModal}
          handleClose={handleInvisibleModal}
        />
      )}
      {isVisibleFilterModal && (
        <TripFilterModal
          visible={isVisibleFilterModal}
          setTripDetails={setUpComingTrip}
          filterValue={tabValue}
          handleClose={() => setIsVisibleFilterModal(false)}
        />
      )}
    </View>
  );
};
export default TripDashbaord;
